export const GET_PROFILE_LEADERBOARDS_REQUEST = 'GET_PROFILE_LEADERBOARDS_REQUEST';
export const GET_PROFILE_LEADERBOARDS_SUCCESS = 'GET_PROFILE_LEADERBOARDS_SUCCESS';
export const GET_PROFILE_LEADERBOARDS_FAILED = 'GET_PROFILE_LEADERBOARDS_FAILED';

export const GET_WORKOUT_LEADERBOARDS_REQUEST = 'GET_WORKOUT_LEADERBOARDS_REQUEST';
export const GET_WORKOUT_LEADERBOARDS_SUCCESS = 'GET_WORKOUT_LEADERBOARDS_SUCCESS';
export const GET_WORKOUT_LEADERBOARDS_FAILED = 'GET_WORKOUT_LEADERBOARDS_FAILED';

export const LOAD_MORE_PROFILE_LEADERBOARDS_REQUEST = 'LOAD_MORE_PROFILE_LEADERBOARDS_REQUEST';
export const LOAD_MORE_PROFILE_LEADERBOARDS_SUCCESS = 'LOAD_MORE_PROFILE_LEADERBOARDS_SUCCESS';
export const LOAD_MORE_PROFILE_LEADERBOARDS_FAILED = 'LOAD_MORE_PROFILE_LEADERBOARDS_FAILED';

export const LOAD_MORE_WORKOUT_LEADERBOARDS_REQUEST = 'LOAD_MORE_WORKOUT_LEADERBOARDS_REQUEST';
export const LOAD_MORE_WORKOUT_LEADERBOARDS_SUCCESS = 'LOAD_MORE_WORKOUT_LEADERBOARDS_SUCCESS';
export const LOAD_MORE_WORKOUT_LEADERBOARDS_FAILED = 'LOAD_MORE_WORKOUT_LEADERBOARDS_FAILED';

export const GET_LEADERBOARDS_FOR_SLIDER_REQUEST = 'GET_LEADERBOARDS_FOR_SLIDER_REQUEST';
export const GET_LEADERBOARDS_FOR_SLIDER_SUCCESS = 'GET_LEADERBOARDS_FOR_SLIDER_SUCCESS';
export const GET_LEADERBOARDS_FOR_SLIDER_FAILED = 'GET_LEADERBOARDS_FOR_SLIDER_FAILED';

export const RESET_LEADERBOARDS_SCROLL = 'RESET_LEADERBOARDS_SCROLL';

export const UPDATE_LEADERBOARD_USERS_REQUEST = 'UPDATE_LEADERBOARD_USERS_REQUEST';
export const UPDATE_LEADERBOARD_USERS_SUCCESS = 'UPDATE_LEADERBOARD_USERS_SUCCESS';
export const UPDATE_LEADERBOARD_USERS_FAILED = 'UPDATE_LEADERBOARD_USERS_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/LeaderboardsActionTypes.js